var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.94391C6 4.66118 8.68629 2 12 2C15.3137 2 18 4.66118 18 7.94391C18 11.5193 14.5745 14.0978 12.4784 15.1495C12.176 15.3013 11.824 15.3013 11.5216 15.1495C9.42553 14.0978 6 11.5193 6 7.94391ZM12.0003 10.3586C13.289 10.3586 14.3336 9.31076 14.3336 8.01819C14.3336 6.72561 13.289 5.67777 12.0003 5.67777C10.7116 5.67777 9.66698 6.72561 9.66698 8.01819C9.66698 9.31076 10.7116 10.3586 12.0003 10.3586Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90936 5.50684C4.64421 6.26943 4.5 7.08911 4.5 7.94394C4.5 10.2403 5.60142 12.1268 6.87099 13.5152C6.99494 13.6507 7.12148 13.7827 7.25 13.9109V22L3.6712 21.3998C2.70683 21.238 2 20.3984 2 19.4146V7.39467C2 6.15102 3.10973 5.20502 4.3288 5.40947L4.90936 5.50684Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 15.1991V21.9371L15.25 20.3019V15.1991C14.5086 15.7497 13.7749 16.1857 13.1478 16.5003C12.4239 16.8636 11.5761 16.8636 10.8522 16.5003C10.2251 16.1857 9.49141 15.7497 8.75 15.1991Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 13.9109C16.8785 13.7827 17.0051 13.6507 17.129 13.5152C18.3986 12.1268 19.5 10.2403 19.5 7.94395C19.5 6.68002 19.1847 5.49292 18.6294 4.45361L20.3288 4.73862C21.2932 4.90036 22 5.73999 22 6.72382V18.7437C22 19.9874 20.8903 20.9334 19.6712 20.7289L16.75 20.239V13.9109Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.fe90949cde75fff66d5aeb365c6f6866.svg";
export { ForwardRef as ReactComponent };